(function () {
  var VERSION = "20260722-welcome-manual-code-v1";
  if (window.__tk9WelcomeDiscountBridgeVersion === VERSION) return;
  window.__tk9WelcomeDiscountBridgeVersion = VERSION;

  var config = Object.assign({
    code: "WELCOME",
    enabled: false,
    storageKey: "tk9_welcome_discount_code",
    appliedAtKey: "tk9_welcome_discount_applied_at",
    source: "postscript_welcome_popup",
    popupRequiredText: "WELCOME",
    promiseOffer: "up_to_25_setup_savings",
    promiseState: "welcome_ready",
    orderAttributeName: "Cart discount",
    successRequiredText: "",
    successRequiredTextPattern: null,
    applyLabel: "COPY CODE",
    applyingLabel: "COPYING...",
    appliedLabel: "CODE COPIED",
    autoApplyOnSuccess: false,
    autoApplyDelayMs: 150,
    closeAfterApply: true,
    closeDelayMs: 700,
    buttonTextPattern: /continue|apply|copy|shop/i,
    scanMs: 250,
    scanLimitMs: 30000
  }, window.TeamK9WelcomeDiscountBridgeConfig || {});

  function normalizeCode(value) {
    return String(value || "").trim().toUpperCase().replace(/[^A-Z0-9_-]/g, "");
  }

  if (normalizeCode(config.code) === "K9WELCOME") {
    config.code = "WELCOME";
    config.popupRequiredText = "WELCOME";
    config.promiseState = "welcome_ready";
    if (String(config.source || "").toLowerCase() === "postscript_k9welcome_popup") {
      config.source = "postscript_welcome_popup";
    }
  }

  // Auto-apply was retired by the owner on 2026-07-22. Keep this asset as a
  // hard no-op so stale layout/config shards cannot turn cart mutation back on.
  [window.localStorage, window.sessionStorage].forEach(function (storage) {
    try {
      storage.removeItem(config.storageKey);
      storage.removeItem(config.appliedAtKey);
    } catch (error) {}
  });
  try {
    document.cookie = config.storageKey + "=; path=/; max-age=0; SameSite=Lax";
  } catch (error) {}
  return;

  function cleanCode(value) {
    return normalizeCode(value || config.code || "");
  }

  function code() {
    return cleanCode(config.code);
  }

  function isLegacyWelcomeCode(value) {
    return normalizeCode(value) === "K9WELCOME";
  }

  function isCurrentOrLegacyWelcomeCode(value) {
    var nextCode = cleanCode(value);
    return nextCode === code() || isLegacyWelcomeCode(nextCode);
  }

  function safeStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {}
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function storedCode() {
    try {
      return cleanCode(window.localStorage.getItem(config.storageKey));
    } catch (error) {
      return "";
    }
  }

  function rememberCode(value) {
    var nextCode = cleanCode(value);
    if (!nextCode) return;
    safeStorageSet(config.storageKey, nextCode);
    safeStorageSet(config.appliedAtKey, new Date().toISOString());
    try {
      document.cookie = config.storageKey + "=" + encodeURIComponent(nextCode) + "; path=/; max-age=1209600; SameSite=Lax";
    } catch (error) {}
  }

  function copyWithFallback(value) {
    var text = cleanCode(value);
    if (!text) return Promise.resolve(false);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(function () {
        return true;
      }).catch(function () {
        return legacyCopy(text);
      });
    }
    return Promise.resolve(legacyCopy(text));
  }

  function legacyCopy(text) {
    var input = document.createElement("textarea");
    input.value = text;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.left = "-9999px";
    input.style.top = "0";
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, text.length);
    var ok = false;
    try {
      ok = document.execCommand("copy");
    } catch (error) {}
    input.remove();
    return ok;
  }

  function fetchJson(url, options) {
    return fetch(url, Object.assign({
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    }, options || {})).then(function (response) {
      return response.text().then(function (text) {
        var json = {};
        try {
          json = text ? JSON.parse(text) : {};
        } catch (error) {}
        if (!response.ok) {
          var failure = new Error("Request failed");
          failure.status = response.status;
          failure.response = json;
          throw failure;
        }
        return json;
      });
    });
  }

  function mergeCartAttributes(cart, value) {
    var attributes = Object.assign({}, cart && cart.attributes || {});
    var nextCode = cleanCode(value);
    attributes[config.orderAttributeName || "Cart discount"] = nextCode;
    attributes._tk9_discount_code = nextCode;
    attributes._tk9_discount_source = config.source;
    attributes._tk9_discount_promise_state = config.promiseState;
    attributes._tk9_discount_promise_code = nextCode;
    attributes._tk9_discount_promise_offer = config.promiseOffer;
    attributes._tk9_discount_promise_source = config.source;
    attributes._tk9_discount_promise_at = new Date().toISOString();
    return attributes;
  }

  function updateCartDiscount(value) {
    var nextCode = cleanCode(value);
    if (!nextCode) return Promise.resolve(false);
    return fetchJson("/cart.js").catch(function () {
      return { attributes: {} };
    }).then(function (cart) {
      return fetchJson("/cart/update.js", {
        method: "POST",
        body: JSON.stringify({
          discount: nextCode,
          attributes: mergeCartAttributes(cart, nextCode)
        })
      });
    }).then(function (cart) {
      dispatchDiscountEvents(nextCode, cart, "cart_update_bridge");
      return cart;
    });
  }

  function dispatchDiscountEvents(value, cart, source) {
    var detail = {
      tk9_discount_code: cleanCode(value),
      tk9_discount_source: source || config.source,
      tk9_cart_total_after: Number(cart && cart.total_price) || 0,
      tk9_cart_discount_savings: Number(cart && cart.total_discount) || 0
    };
    ["tk9_discount_apply", "tk9_slide_cart_discount_applied", "cart:updated", "cart:refresh"].forEach(function (name) {
      try {
        var event = new CustomEvent(name, { detail: detail });
        document.dispatchEvent(event);
        window.dispatchEvent(event);
      } catch (error) {}
    });
  }

  function triggerSlideCartApply(value) {
    var nextCode = cleanCode(value);
    if (!nextCode) return false;
    var button = document.createElement("button");
    button.type = "button";
    button.hidden = true;
    button.setAttribute("data-tk9-apply-discount", nextCode);
    button.setAttribute("data-tk9-discount-source", config.source);
    button.setAttribute("aria-hidden", "true");
    button.textContent = "Apply " + nextCode;
    document.body.appendChild(button);
    try {
      button.click();
      return true;
    } catch (error) {
      return false;
    } finally {
      window.setTimeout(function () {
        if (button && button.parentNode) button.parentNode.removeChild(button);
      }, 500);
    }
  }

  function applyCode(value) {
    var nextCode = cleanCode(value);
    if (!nextCode) return Promise.resolve(false);
    rememberCode(nextCode);

    var confirmed = false;
    function onApplied(event) {
      var eventCode = cleanCode(event && event.detail && event.detail.tk9_discount_code);
      if (eventCode === nextCode) confirmed = true;
    }

    document.addEventListener("tk9_discount_apply", onApplied, { once: true });
    var delegated = triggerSlideCartApply(nextCode);

    return new Promise(function (resolve) {
      window.setTimeout(function () {
        document.removeEventListener("tk9_discount_apply", onApplied);
        if (confirmed) {
          resolve(true);
          return;
        }
        updateCartDiscount(nextCode).then(function () {
          resolve(true);
        }).catch(function () {
          resolve(false);
        });
      }, delegated ? 900 : 0);
    });
  }

  // Sale containment (2026-07-02, owner-directed): NEVER displace a code the
  // shopper already has on the cart. While any other order code (e.g. USA)
  // is applied, every checkout-link patch is a no-op and previously patched
  // links/inputs are reverted. Refreshes from /cart.js on load and after any
  // cart/discount event.
  var otherCartCode = false;
  var legacyCartSwapInFlight = false;
  function refreshCartCodeState() {
    fetchJson("/cart.js").then(function (cart) {
      var apps = (cart && cart.cart_level_discount_applications) || [];
      var hasLegacyWelcome = false;
      var next = apps.some(function (app) {
        var appCode = cleanCode(app && (app.title || app.code));
        if (!appCode) return false;
        if (isLegacyWelcomeCode(appCode)) {
          hasLegacyWelcome = true;
          return false;
        }
        return !isCurrentOrLegacyWelcomeCode(appCode);
      });
      if (next && !otherCartCode) unpatchCheckoutLinks();
      otherCartCode = next;
      if (hasLegacyWelcome && !next && !legacyCartSwapInFlight) {
        legacyCartSwapInFlight = true;
        updateCartDiscount(code()).catch(function () {}).then(function () {
          legacyCartSwapInFlight = false;
        });
      }
    }).catch(function () {});
  }

  function unpatchCheckoutLinks() {
    var ourCode = code();
    Array.prototype.slice.call(document.querySelectorAll('a[href*="discount="]')).forEach(function (link) {
      try {
        var url = new URL(link.getAttribute("href") || "", window.location.origin);
        if (cleanCode(url.searchParams.get("discount")) === ourCode) {
          url.searchParams.delete("discount");
          link.setAttribute("href", url.pathname + url.search + url.hash);
        }
      } catch (error) {}
    });
    Array.prototype.slice.call(document.querySelectorAll('input[name="discount"][data-tk9-welcome-bridge]')).forEach(function (input) {
      if (input.parentNode) input.parentNode.removeChild(input);
    });
  }

  function checkoutUrlWithDiscount(rawHref, value) {
    var nextCode = cleanCode(value || storedCode());
    if (!nextCode) return rawHref;
    try {
      var url = new URL(rawHref || "/checkout", window.location.origin);
      if (url.pathname.indexOf("/checkout") !== 0) return rawHref;
      url.searchParams.set("discount", nextCode);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return rawHref || "/checkout?discount=" + encodeURIComponent(nextCode);
    }
  }

  function patchCheckoutLinks(root) {
    if (otherCartCode) return;
    var nextCode = storedCode();
    if (!nextCode) return;
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice.call(scope.querySelectorAll('a[href^="/checkout"], a[href*="/checkout?"]')).forEach(function (link) {
      var href = link.getAttribute("href") || "/checkout";
      var nextHref = checkoutUrlWithDiscount(href, nextCode);
      if (nextHref && nextHref !== href) link.setAttribute("href", nextHref);
    });
    Array.prototype.slice.call(scope.querySelectorAll('form[action^="/checkout"], form[action="/cart"]')).forEach(function (form) {
      var hidden = form.querySelector('input[name="discount"]');
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "discount";
        hidden.setAttribute("data-tk9-welcome-bridge", "1");
        form.appendChild(hidden);
      }
      hidden.value = nextCode;
    });
  }

  function composedPath(event) {
    if (event.composedPath) return event.composedPath();
    var path = [];
    var node = event.target;
    while (node) {
      path.push(node);
      node = node.parentNode || node.host;
    }
    path.push(window);
    return path;
  }

  function nodeText(node) {
    return String(node && (node.innerText || node.textContent || node.value || "") || "").replace(/\s+/g, " ").trim();
  }

  function popupText(host) {
    if (!host) return "";
    var root = host.shadowRoot || host;
    var textNodes = [];
    try {
      textNodes = Array.prototype.slice.call(root.querySelectorAll(
        "h1,h2,h3,h4,p,span,strong,code,label,button,input,[role='heading'],[role='button'],[data-code]"
      ));
    } catch (error) {}
    return textNodes.filter(function (node) {
      var rect = node.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return false;
      var style = window.getComputedStyle(node);
      return style.display !== "none" && style.visibility !== "hidden" && Number(style.opacity || 1) > 0;
    }).map(nodeText).filter(Boolean).join(" ");
  }

  function hasVisibleWelcomeCode(host) {
    if (!host) return false;
    var root = host.shadowRoot || host;
    var nodes = [];
    try {
      nodes = Array.prototype.slice.call(root.querySelectorAll(
        "h1,h2,h3,h4,p,span,strong,code,button,[data-code]"
      ));
    } catch (error) {}
    return nodes.some(function (node) {
      var rect = node.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return false;
      var style = window.getComputedStyle(node);
      if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity || 1) <= 0) return false;
      return /^(?:CODE\s*:\s*)?WELCOME$/i.test(nodeText(node));
    });
  }

  function isWelcomePopup(host) {
    if (!hasVisibleWelcomeCode(host)) return false;
    var text = popupText(host).toUpperCase();
    if (text.indexOf(String(config.popupRequiredText || "WELCOME").toUpperCase()) === -1) return false;
    var required = String(config.successRequiredText || "").trim();
    if (required) return text.indexOf(required.toUpperCase()) !== -1;
    var pattern = config.successRequiredTextPattern;
    if (pattern && typeof pattern.test === "function") return pattern.test(text);
    return true;
  }

  function findPostscriptHost(path) {
    for (var index = 0; index < path.length; index += 1) {
      var node = path[index];
      if (node && node.tagName === "POSTSCRIPT-POPUP") return node;
      if (node && node.host && node.host.tagName === "POSTSCRIPT-POPUP") return node.host;
    }
    return null;
  }

  function findButton(path) {
    for (var index = 0; index < path.length; index += 1) {
      var node = path[index];
      if (node && node.tagName === "BUTTON") return node;
      if (node && node.closest) {
        var button = node.closest("button");
        if (button) return button;
      }
    }
    return null;
  }

  function setButtonState(button, label) {
    if (!button) return;
    button.textContent = label;
    button.setAttribute("aria-label", label + " " + code());
    button.setAttribute("data-tk9-welcome-apply-code", code());
  }

  function maybeAutoApplyCode(host) {
    if (!config.autoApplyOnSuccess || !host) return;
    var nextCode = code();
    if (!nextCode || host.__tk9WelcomeAutoAppliedCode === nextCode) return;
    host.__tk9WelcomeAutoAppliedCode = nextCode;
    window.setTimeout(function () {
      applyCode(nextCode).then(function (applied) {
        if (applied) notifyOfferSuccess(host);
      }).catch(function () {
        host.__tk9WelcomeAutoAppliedCode = "";
      });
    }, Math.max(0, Number(config.autoApplyDelayMs) || 0));
  }

  function notifyOfferSuccess(host) {
    if (host && host.__tk9WelcomeSuccessNotified) return;
    if (host) host.__tk9WelcomeSuccessNotified = true;
    try {
      window.dispatchEvent(new CustomEvent("tk9DogOfferSuccess", {
        detail: { code: code(), source: config.source }
      }));
    } catch (error) {}
  }

  function closePostscriptPopup(host) {
    if (!host) return false;
    var root = host.shadowRoot || host;
    var clicked = false;
    var selectors = [
      'button[aria-label*="close" i]',
      'button[aria-label*="dismiss" i]',
      '[role="button"][aria-label*="close" i]',
      '[role="button"][aria-label*="dismiss" i]',
      'button'
    ];
    for (var selectorIndex = 0; selectorIndex < selectors.length && !clicked; selectorIndex += 1) {
      var nodes = [];
      try {
        nodes = Array.prototype.slice.call(root.querySelectorAll(selectors[selectorIndex]));
      } catch (error) {
        nodes = [];
      }
      clicked = nodes.some(function (node) {
        var label = String(node.getAttribute("aria-label") || node.title || nodeText(node) || "").trim();
        var looksClose = /close|dismiss|no thanks|^×$|^x$/i.test(label);
        if (!looksClose && selectors[selectorIndex] !== "button") return false;
        if (!looksClose && selectors[selectorIndex] === "button") return false;
        try {
          node.click();
          return true;
        } catch (error) {
          return false;
        }
      });
    }
    return clicked;
  }

  function polishPopup(host) {
    if (!host || !host.shadowRoot || !isWelcomePopup(host)) return false;
    maybeAutoApplyCode(host);
    var buttons = Array.prototype.slice.call(host.shadowRoot.querySelectorAll("button"));
    var button = buttons.find(function (item) {
      var text = nodeText(item);
      return config.buttonTextPattern.test(text) || item.getAttribute("data-tk9-welcome-apply-code");
    });
    if (!button) return false;
    if (nodeText(button) !== config.applyLabel) setButtonState(button, config.applyLabel);
    return true;
  }

  function handlePostscriptClick(event) {
    var path = composedPath(event);
    var host = findPostscriptHost(path);
    if (!host || !isWelcomePopup(host)) return;
    var button = findButton(path);
    if (!button) return;
    var text = nodeText(button);
    if (!button.getAttribute("data-tk9-welcome-apply-code") && !config.buttonTextPattern.test(text)) return;

    var nextCode = code();
    setButtonState(button, config.applyingLabel);
    copyWithFallback(nextCode).catch(function () {});
    applyCode(nextCode).then(function (applied) {
      if (!applied) {
        if (button && button.isConnected) setButtonState(button, config.applyLabel);
        return;
      }
      notifyOfferSuccess(host);
      setButtonState(button, config.appliedLabel);
      if (config.closeAfterApply) {
        window.setTimeout(function () {
          closePostscriptPopup(host);
        }, Math.max(0, Number(config.closeDelayMs) || 0));
      }
      window.setTimeout(function () {
        if (button && button.isConnected) setButtonState(button, config.applyLabel);
      }, 1600);
    }).catch(function () {
      if (button && button.isConnected) setButtonState(button, config.applyLabel);
    });
  }

  function handleCheckoutClick(event) {
    if (otherCartCode) return;
    var nextCode = storedCode();
    if (!nextCode) return;
    var target = event.target;
    var link = target && target.closest && target.closest('a[href^="/checkout"], a[href*="/checkout?"]');
    if (link) {
      link.setAttribute("href", checkoutUrlWithDiscount(link.getAttribute("href") || "/checkout", nextCode));
      return;
    }
    var submit = target && target.closest && target.closest('button[name="checkout"], input[name="checkout"], [data-tk9-checkout]');
    if (submit) {
      var form = submit.closest && submit.closest("form");
      if (form) patchCheckoutLinks(form);
    }
  }

  function scanPopups() {
    Array.prototype.slice.call(document.querySelectorAll("postscript-popup")).forEach(function (host) {
      polishPopup(host);
      if (host.shadowRoot && !host.__tk9WelcomeBridgeObserver) {
        host.__tk9WelcomeBridgeObserver = new MutationObserver(function () {
          polishPopup(host);
        });
        host.__tk9WelcomeBridgeObserver.observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  // The config code is the single source of truth. Replace any previously
  // stored code so old K9WELCOME/USA tails do not outlive the active offer.
  if (storedCode() && storedCode() !== code()) rememberCode(code());

  refreshCartCodeState();
  ["tk9_discount_apply", "tk9_slide_cart_discount_applied", "cart:updated", "cart:update", "cart:refresh", "cart:change"].forEach(function (name) {
    document.addEventListener(name, function () {
      window.setTimeout(refreshCartCodeState, 400);
    });
  });

  document.addEventListener("click", handlePostscriptClick, true);
  document.addEventListener("click", handleCheckoutClick, true);
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (form && form.matches && (form.matches('form[action^="/checkout"]') || form.matches('form[action="/cart"]'))) {
      patchCheckoutLinks(form);
    }
  }, true);

  var pageObserver = new MutationObserver(function () {
    scanPopups();
    patchCheckoutLinks(document);
  });
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });

  var elapsed = 0;
  var timer = window.setInterval(function () {
    elapsed += config.scanMs;
    scanPopups();
    patchCheckoutLinks(document);
    if (elapsed >= config.scanLimitMs) window.clearInterval(timer);
  }, config.scanMs);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scanPopups();
      patchCheckoutLinks(document);
    }, { once: true });
  } else {
    scanPopups();
    patchCheckoutLinks(document);
  }

  window.TeamK9WelcomeDiscountBridge = {
    apply: applyCode,
    copy: copyWithFallback,
    patchCheckoutLinks: patchCheckoutLinks,
    scanPopups: scanPopups,
    version: VERSION
  };
})();
